/* istanbul ignore file */

import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { IMessageResponse, IMessageRequest } from "./MessageId.state";

const buildRequestConfig = (version: number) => ({
  headers: {
    "If-Match": `${version}`
  }
});

export const getMessageData = async (messageId: string) => (await getClientFor(mainApi.name).get<IMessageResponse>(`/messages/${messageId}`)).data;
export const addMessage = async (message: IMessageRequest, version: number) => await getClientFor(mainApi.name).post(`/messages`, message, buildRequestConfig(version));
export const updateMessage = async (message: IMessageRequest, version: number) => await getClientFor(mainApi.name).put(`/messages`, message, buildRequestConfig(version));

export const approveMessage = async (messageId: string, version: number) =>
  await getClientFor(mainApi.name).post(`/messages/${messageId}/approve`, null, buildRequestConfig(version));

export const obsoleteMessage = async (messageId: string, version: number) => await getClientFor(mainApi.name).delete(`/messages/${messageId}`, buildRequestConfig(version));

export const deprecateMessage = async (messageId: string, version: number) =>
  await getClientFor(mainApi.name).post(`/messages/${messageId}/status`, null, buildRequestConfig(version));
